import { memo } from 'react'
import { AnimatedSection } from '../animations/AnimatedSection'

interface FinalCTASectionProps {
  isAuthenticated: boolean
  onSignUpClick: () => void
  onDashboardClick: () => void
  onPricingClick: () => void
}

export const FinalCTASection = memo(function FinalCTASection({ 
  isAuthenticated, 
  onSignUpClick, 
  onDashboardClick,
  onPricingClick 
}: FinalCTASectionProps) {
  return (
    <section className="section-spacing bg-surface-elevated px-4 sm:px-6" aria-labelledby="final-cta-heading">
      <div className="container-custom">
        <AnimatedSection animation="fade-up">
          <div className="text-center max-w-3xl mx-auto">
            <h2 id="final-cta-heading" className="text-3xl sm:text-4xl font-bold text-text mb-3 sm:mb-4">
              Every day you call AI APIs directly,{' '}
              <span className="text-gradient">you're overpaying.</span>
            </h2>
            <p className="text-lg sm:text-xl text-text-muted mb-3 sm:mb-4 px-4">
              Join the beta and get unified access to all major models today - with cost optimization features rolling out as we build them.
            </p>
            <p className="text-sm text-text-muted/60 mb-6 sm:mb-8 px-4">
              No lock-in. Cancel anytime. Early adopters shape the roadmap.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center items-stretch sm:items-center max-w-md sm:max-w-none mx-auto px-4 sm:px-0">
              {isAuthenticated ? (
                <button
                  onClick={onDashboardClick}
                  className="btn btn-primary btn-lg btn-enhanced w-full sm:w-auto min-h-[44px]"
                  aria-label="Navigate to your dashboard"
                >
                  Go to Dashboard
                </button>
              ) : (
                <button
                  onClick={onSignUpClick}
                  className="btn btn-primary btn-lg btn-enhanced w-full sm:w-auto min-h-[44px]"
                  aria-label="Sign up to join the beta"
                >
                  Start Saving on AI
                </button>
              )}
              <button
                onClick={onPricingClick}
                className="btn btn-secondary btn-lg btn-enhanced w-full sm:w-auto min-h-[44px]"
                aria-label="View pricing plans"
              >
                See Pricing
              </button>
            </div>
          </div>
        </AnimatedSection>
      </div>
    </section>
  )
})
